var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.283 13.251H17.62l-6.263 6.106c-.5.488-.5 1.289 0 1.777s1.309.488 1.81 0l8.458-8.246c.5-.488.5-1.276 0-1.764l-8.446-8.258a1.3 1.3 0 0 0-1.81 0c-.5.488-.5 1.276 0 1.764l6.251 6.119H3.283C2.578 10.749 2 11.312 2 12s.578 1.251 1.283 1.251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow_forward.d942f44a9143c05bf4c4beae928622c4.svg";
export { ForwardRef as ReactComponent };